module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    attrs: {
      "id": "header-title"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/common/logo_header.svg"),
      "alt": "Ralph Creative PR"
    }
  })])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "shadow"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "navbar"
    }
  }, [_c('ul', [_c('li', [_vm._v("WEBSITE")]), _vm._v(" "), _c('li', [_vm._v("ARCHIVE")]), _vm._v(" "), _c('li', [_vm._v("CONTACT")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-767fc617!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/Navbar.vue
// module id = 34
// module chunks = 1